// extracted by mini-css-extract-plugin
module.exports = {"terms-page":"styles_terms-page__1UKza","content":"styles_content__3SJpw","last-modified":"styles_last-modified__1OeBb"};